import { setTheme } from "theme/default/setTheme";

export const setFontSize_24px = setTheme(({ theme }) => `font-size: ${theme.fontSize.font_size_24px}`);
